export default __webpack_public_path__ + "static/media/ChangeReport.73af1df3.svg";